import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { DS } from '../../lib/design-system';

interface CalendarHeaderProps {
  currentDate: Date;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  viewMode: 'week' | 'month';
  onViewModeChange: (mode: 'week' | 'month') => void;
  isMobile: boolean;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  onPrevMonth,
  onNextMonth,
  viewMode,
  onViewModeChange,
  isMobile,
}) => {
  const monthName = currentDate.toLocaleString('es-ES', { month: 'long', year: 'numeric' });

  return (
    <div className="flex-none border-b border-gray-200 bg-white">
      {/* Month Name - Only show in month view */}
      {viewMode === 'month' && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <h3 className="text-sm font-semibold text-gray-900 capitalize">
            {currentDate.toLocaleString('es-ES', { month: 'long' })}
          </h3>
          <div className="flex items-center gap-1">
            <motion.button
              whileTap={DS.animations.buttonTap}
              onClick={onPrevMonth}
              className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ChevronLeft size={18} className="text-gray-600" />
            </motion.button>
            <motion.button
              whileTap={DS.animations.buttonTap}
              onClick={onNextMonth}
              className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ChevronRight size={18} className="text-gray-600" />
            </motion.button>
          </div>
        </div>
      )}
    </div>
  );
};
